var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYorkdigital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Grupo_8262",
    "data-name": "Grupo 8262",
    width: 106.531,
    height: 41.066,
    viewBox: "0 0 106.531 41.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\xE2ngulo_3532",
    "data-name": "Ret\xE2ngulo 3532",
    width: 106.531,
    height: 41.066,
    fill: "#000000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8261",
    "data-name": "Grupo 8261",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14165",
    "data-name": "Caminho 14165",
    d: "M317.542,48.432v15.1h6.191v-15.1A6.779,6.779,0,0,1,330.5,41.66h6.979V35.469H330.5a12.977,12.977,0,0,0-12.962,12.963",
    transform: "translate(-259.149 -28.947)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14166",
    "data-name": "Caminho 14166",
    d: "M21.429,34.65,14.446,49.859,6.909,34.65H0L11.123,57.1,9.507,60.613a4.37,4.37,0,0,1-3.961,2.54H1.925v6.191H5.547A10.577,10.577,0,0,0,15.133,63.2L28.241,34.65Z",
    transform: "translate(0 -28.278)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14167",
    "data-name": "Caminho 14167",
    d: "M451.279,34.64V25.952a19.109,19.109,0,0,0,3.458-.513l7.177,9.2h7.857L460.623,22.9a19.2,19.2,0,0,0,8.786-16.117h-6.191a13.023,13.023,0,0,1-11.939,12.961V0h-6.191V34.64Z",
    transform: "translate(-363.24 0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14168",
    "data-name": "Caminho 14168",
    d: "M160.357,35.935a14.059,14.059,0,0,0-4.972,26.7,1.305,1.305,0,0,0,1.484-.261l1.322-1.322a4.606,4.606,0,0,1,6.515,0l1.322,1.322a1.3,1.3,0,0,0,1.481.262,14.059,14.059,0,0,0-7.152-26.7M162.089,57.8a7.872,7.872,0,1,1,7.2-7.2,7.88,7.88,0,0,1-7.2,7.2",
    transform: "translate(-120.283 -29.293)",
    fill: "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYorkdigital);
export default __webpack_public_path__ + "static/media/yorkdigital.56db6f1d48fc089167fbf2c389264574.svg";
export { ForwardRef as ReactComponent };